import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Settings2, Inbox } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "../lib/api";
import { FollowUpCard } from "../components/FollowUpCard";
import { FloatingShapes } from "../components/FloatingShapes";

const TABS = [["aperto", "Da fare"], ["inviato", "Inviati"], ["ignorato", "Ignorati"]];

export default function FollowUps() {
  const [tab, setTab] = useState("aperto");
  const [data, setData] = useState({ items: [], aperti: 0 });
  const [settings, setSettings] = useState(null);

  const load = useCallback(async () => {
    try {
      const [f, s] = await Promise.all([api.get("/followups", { params: { stato: tab } }), api.get("/mail/settings")]);
      setData(f.data);
      setSettings(s.data);
    } catch (e) { toast.error(errorMessage(e)); }
  }, [tab]);

  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [load]);

  return (
    <div data-testid="followups-page" className="relative space-y-8">
      <FloatingShapes />
      <div className="fade-up relative z-10 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-xs font-mono uppercase tracking-widest text-muted-foreground">Dopo la chiamata</p>
          <h1 className="mt-2 text-4xl font-bold tracking-tight sm:text-5xl">Follow-up</h1>
          <p className="mt-2 text-sm text-muted-foreground">Email promesse e appuntamenti fissati in Live o al telefono: la bozza è già pronta, tu rivedi e invii.</p>
        </div>
        <Link to="/impostazioni" data-testid="followups-settings-link" className={`inline-flex items-center gap-2 self-start rounded-full border px-5 py-3 text-sm font-semibold transition-all hover:-translate-y-0.5 ${settings && !settings.configurato ? "border-amber-500/50 bg-amber-500/10 text-amber-200" : "border-border text-muted-foreground hover:text-white"}`}>
          <Settings2 className="h-4 w-4" /> {settings && !settings.configurato ? "Configura la posta" : "Impostazioni posta"}
        </Link>
      </div>

      <div className="relative z-10 inline-flex rounded-full bg-secondary p-1">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`followups-tab-${k}`} onClick={() => setTab(k)} className={`rounded-full px-4 py-1.5 text-xs font-medium transition-all ${tab === k ? "bg-card text-white shadow" : "text-muted-foreground"}`}>
            {l}{k === "aperto" && data.aperti > 0 && <span className="ml-2 rounded-full bg-primary px-1.5 py-0.5 text-[10px] font-bold text-white">{data.aperti}</span>}
          </button>
        ))}
      </div>

      {data.items.length === 0 ? (
        <div data-testid="followups-empty" className="surface relative z-10 flex flex-col items-center gap-3 p-12 text-center text-sm text-muted-foreground">
          {tab === "aperto" ? <Inbox className="h-8 w-8 text-primary" /> : <Mail className="h-8 w-8 text-muted-foreground" />}
          {tab === "aperto" ? "Nessun impegno in sospeso. Quando in una chiamata prometti una mail o fissi un appuntamento, lo troverai qui." : "Niente da mostrare."}
        </div>
      ) : (
        <ul className="stagger relative z-10 space-y-3">{data.items.map((it) => <FollowUpCard key={it.id} item={it} onChange={load} />)}</ul>
      )}
    </div>
  );
}
